import React from "react"
import { numFixer } from "./Functions"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faBan,
  faEdit,
  faEye,
  faMars,
  faStar,
  faTimes,
  faVenus,
  faCrown,
} from "@fortawesome/free-solid-svg-icons"
import { MdCategory } from "react-icons/md"
import { BrandSectorsData } from "../../../../static/Brand"

export const columnConfig = ({
  isAllSelected,
  isIndeterminate,
  handleSelectAll,
  handleSelectRow,
  selectedRecords,
  removeVerification,
  setSelectedUser,
  setIsOpenDetailModal,
  addVerification,
  banUser,
  setIsEditCategoryModalOpen,
  handlePrioritize,
}) => [
  {
    accessor: "select",
    title: (
      <input
        type="checkbox"
        checked={isAllSelected}
        ref={(input) => {
          if (input) {
            input.indeterminate = isIndeterminate
          }
        }}
        onChange={(e) => handleSelectAll(e.target.checked)}
      />
    ),
    sortable: false,
    render: ({ _id }) => (
      <input
        type="checkbox"
        checked={selectedRecords.includes(_id)}
        onChange={() => handleSelectRow(_id)}
      />
    ),
  },
  {
    accessor: "id",
    title: "Id",
    sortable: true,
    render: (record) => (
      <div
        onClick={() => {
          setSelectedUser(record)
          setIsOpenDetailModal(true)
        }}
        style={{ cursor: "pointer" }}
      ></div>
    ),
  },
  {
    accessor: "verification",
    title: "Onay Durumu",
    sortable: true,
    render: ({ verification, _id }: { verification: boolean; _id: string }) => (
      <div className="text-center items-center">
        {verification ? (
          <FontAwesomeIcon
            icon={faStar}
            style={{ color: "#ffba00", cursor: "pointer" }}
            onClick={() => removeVerification(_id)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faTimes}
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => addVerification(_id)}
          />
        )}
      </div>
    ),
  },
  {
    accessor: "prioritized",
    title: "Öncelik Durumu",
    sortable: true,
    render: ({ prioritized, _id }: { prioritized: boolean; _id: string }) => (
      <div className="text-center items-center">
        {prioritized ? (
          <FontAwesomeIcon
            icon={faCrown}
            style={{ color: "#ffba00", cursor: "pointer" }}
            onClick={() => handlePrioritize(_id, false)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faTimes}
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => handlePrioritize(_id, true)}
          />
        )}
      </div>
    ),
  },
  {
    accessor: "details",
    title: "Detaylar",
    sortable: true,
    render: ({ _id }: { _id: string }) => (
      <a href={`/user/find/${_id}`} target="_blank" rel="noopener noreferrer">
        <div className="text-center items-center">
          <FontAwesomeIcon icon={faEye} style={{ color: "#005eff" }} />
        </div>
      </a>
    ),
  },
  {
    accessor: "ban_user",
    title: "Kullanıcıyı Banla",
    sortable: true,
    render: ({ _id }) => (
      <div className="text-center items-center">
        <FontAwesomeIcon
          icon={faBan}
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => banUser(_id)}
        />
      </div>
    ),
  },
  {
    accessor: "firstName",
    title: "İsim",
    sortable: true,
    render: (record) => (
      <div
        onClick={() => {
          setSelectedUser(record)
          setIsOpenDetailModal(true)
        }}
        style={{ cursor: "pointer" }}
      >
        {record.name}
      </div>
    ),
  },
  {
    accessor: "phone",
    title: "Telefon",
    sortable: true,
    render: (record) => {
      return record.phone && record.phone.length < 19 ? (
        <div
          className="flex w-full"
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.phone}
        </div>
      ) : (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >{`${record.phone?.slice(0, 19)}..`}</div>
      )
    },
  },
  {
    accessor: "age",
    title: "Yaş",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.age > 65 ? "65" : record.age}
        </div>
      )
    },
  },
  {
    accessor: "job",
    title: "Meslek",
    sortable: true,
    render: (record) => {
      return (
        <div
          className="flex w-full"
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.job}
        </div>
      )
    },
  },
  {
    accessor: "category",
    title: "Kategori",
    sortable: true,
    render: ({
      category,
      sub_category,
      _id,
    }: {
      category: string
      sub_category: (string | { name?: string; category?: string })[] | undefined
      _id: string
    }) => {
      const matchedCategory = BrandSectorsData.find((item) => item.value === category)
      const categoryLabel = matchedCategory ? matchedCategory.name : category || "Kategori Seç"

      const subNames =
        sub_category?.map((sub: string | { name?: string; category?: string }) =>
          typeof sub === "string" ? sub : sub?.name || sub?.category || "",
        ) || []
      const uniqueSubs = Array.from(new Set(subNames.filter((name) => name)))
      const toShow = uniqueSubs.slice(0, 3).join(", ")
      const suffix = uniqueSubs.length > 3 ? " .." : ""

      return (
        <div
          className="flex items-center gap-3 px-4 py-1.5 border border-gray-300 rounded-2xl cursor-pointer hover:bg-gray-100"
          onClick={() => setIsEditCategoryModalOpen({ modal: true, _id })}
          title="Kategori / Alt Kategori Seç"
        >
          {React.createElement(
            MdCategory as unknown as React.ComponentType<{ className?: string }>,
            {
              className: "w-4 h-4 text-black",
            },
          )}
          <div className="flex flex-col">
            <span className="font-medium text-sm">{categoryLabel}</span>
            <span className="text-xs text-gray-600">
              {uniqueSubs.length > 0 ? toShow + suffix : "Alt kategori seçilmedi"}
            </span>
          </div>
          <div className="flex items-center gap-2 ml-auto">
            <FontAwesomeIcon
              icon={faEdit}
              style={{ color: "#005eff", cursor: "pointer" }}
              title="Kategoriyi Düzenle"
              onClick={(e) => {
                e.stopPropagation()
                setIsEditCategoryModalOpen({ modal: true, _id })
              }}
            />
          </div>
        </div>
      )
    },
  },
  {
    accessor: "insta.full_name",
    title: "Insta Tam Adı",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.insta_fullname}
        </div>
      )
    },
  },
  {
    accessor: "insta.username",
    title: "Insta Kullanıcı Adı",
    sortable: true,
    render: (record) => (
      <a
        href={`https://www.instagram.com/${record.insta_username}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center items-center">
          <span>{record.insta_username}</span>
        </div>
      </a>
    ),
  },
  {
    accessor: "tiktok.username",
    title: "TikTok Kullanıcı Adı",
    sortable: true,
    render: (record) => (
      <a
        href={`https://www.tiktok.com/@${record.tiktok.username}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="text-center items-center">
          <span>{record.tiktok.username}</span>
        </div>
      </a>
    ),
  },
  {
    accessor: "gender",
    title: "Cinsiyet",
    sortable: true,
    render: (record) => (
      <div
        className="text-center items-center"
        onClick={() => {
          setSelectedUser(record)
          setIsOpenDetailModal(true)
        }}
      >
        {record.gender === "male" ? (
          <FontAwesomeIcon icon={faMars} style={{ color: "#005eff" }} />
        ) : record.gender === "female" ? (
          <FontAwesomeIcon icon={faVenus} style={{ color: "#ff00dd" }} />
        ) : null}
      </div>
    ),
  },
  {
    accessor: "country",
    title: "Ülke",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.country}
        </div>
      )
    },
  },
  {
    accessor: "application_stats.gained_money",
    title: "Kazanılan Tutar",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.gained_money != null
          ? Number(record.application_stats.gained_money).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.clicks_to_price_ratio",
    title: "Tıklama/Fiyat Oranı",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.clicks_to_price_ratio != null
          ? Number(record.application_stats.clicks_to_price_ratio).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.approval_rate",
    title: "Başvuru Onay Oranı",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.approval_rate != null
          ? Number(record.application_stats.approval_rate).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.rejection_rate",
    title: "Başvuru Red Oranı",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.rejection_rate != null
          ? Number(record.application_stats.rejection_rate).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.averageViews",
    title: "Başvuru Ort. İzlenme",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.averageViews != null
          ? Number(record.application_stats.averageViews).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.averageLikes",
    title: "Başvuru Ort. Beğeni",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.averageLikes != null
          ? Number(record.application_stats.averageLikes).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.averageComments",
    title: "Başvuru Ort. Yorum",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.averageComments != null
          ? Number(record.application_stats.averageComments).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.averageShares",
    title: "Başvuru Ort. Paylaşım",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.averageShares != null
          ? Number(record.application_stats.averageShares).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.averageClicks",
    title: "Başvuru Ort. Tıklama",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.averageClicks != null
          ? Number(record.application_stats.averageClicks).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.engagement_score.score",
    title: "Başvuru Etkileşim Skoru",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.engagement_score?.score != null
          ? Number(record.application_stats.engagement_score.score).toFixed(2)
          : "-"}
      </div>
    ),
  },
  // {
  //   accessor: "application_stats.engagement_score.confidence",
  //   title: "Etkileşim Güven",
  //   sortable: true,
  //   render: (record) => <div>{record?.application_stats?.engagement_score?.confidence ?? "-"}</div>,
  // },
  // {
  //   accessor: "engagement_score_last_updated_at",
  //   title: "Etkileşim Skor Güncelleme",
  //   sortable: true,
  //   render: (record) => (
  //     <div>
  //       {record?.engagement_score_last_updated_at
  //         ? new Date(record.engagement_score_last_updated_at).toLocaleString()
  //         : "-"}
  //     </div>
  //   ),
  // },
  {
    accessor: "application_stats.risk_score.score",
    title: "Risk Skoru",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.risk_score?.score != null
          ? Number(record.application_stats.risk_score.score).toFixed(2)
          : "-"}
      </div>
    ),
  },
  // {
  //   accessor: "application_stats.risk_score.confidence",
  //   title: "Risk Güven",
  //   sortable: true,
  //   render: (record) => <div>{record?.application_stats?.risk_score?.confidence ?? "-"}</div>,
  // },
  // {
  //   accessor: "risk_score_last_updated_at",
  //   title: "Risk Skor Güncelleme",
  //   sortable: true,
  //   render: (record) => (
  //     <div>
  //       {record?.risk_score_last_updated_at
  //         ? new Date(record.risk_score_last_updated_at).toLocaleString()
  //         : "-"}
  //     </div>
  //   ),
  // },
  {
    accessor: "application_stats.is_rising_star.score",
    title: "Yükselen Yıldız",
    sortable: true,
    render: (record) => (
      <div>{record?.application_stats?.is_rising_star?.score ? "Evet" : "Hayır"}</div>
    ),
  },
  {
    accessor: "application_stats.uploading_content_duration",
    title: "İçerik Yükleme Süresi",
    sortable: true,
    render: (record) => <div>{record?.application_stats?.uploading_content_duration ?? "-"}</div>,
  },
  {
    accessor: "application_stats.uploading_content_score.score",
    title: "İçerik Skoru",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.uploading_content_score?.score != null
          ? Number(record.application_stats.uploading_content_score.score).toFixed(2)
          : "-"}
      </div>
    ),
  },
  {
    accessor: "application_stats.engagement_rate_is_rising",
    title: "Engagement Rate Yükselen",
    sortable: true,
    render: (record) => (
      <div>{record?.application_stats?.engagement_rate_is_rising ? "Evet" : "Hayır"}</div>
    ),
  },
  {
    accessor: "application_stats.completed_collaborations_last_month",
    title: "Son Ay Tamamlanan İşbirliği Sayısı",
    sortable: true,
    render: (record) => (
      <div>
        {record?.application_stats?.completed_collaborations_last_month != null
          ? Number(record.application_stats.completed_collaborations_last_month)
          : "-"}
      </div>
    ),
  },
  // {
  //   accessor: "application_stats.uploading_content_score.confidence",
  //   title: "İçerik Skoru Güven",
  //   sortable: true,
  //   render: (record) => (
  //     <div>{record?.application_stats?.uploading_content_score?.confidence ?? "-"}</div>
  //   ),
  // },
  // {
  //   accessor: "uploading_content_score_last_updated_at",
  //   title: "İçerik Skoru Güncelleme",
  //   sortable: true,
  //   render: (record) => (
  //     <div>
  //       {record?.uploading_content_score_last_updated_at
  //         ? new Date(record.uploading_content_score_last_updated_at).toLocaleString()
  //         : "-"}
  //     </div>
  //   ),
  // },
  {
    accessor: "insta.followers",
    title: "Insta Takipçi",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.insta_followers)}
        </div>
      )
    },
  },
  {
    accessor: "insta.following",
    title: "Insta Takip",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.insta_following)}
        </div>
      )
    },
  },
  {
    accessor: "insta.average_like",
    title: "Insta Ortalama Beğeni",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.insta_average_like)}
        </div>
      )
    },
  },
  {
    accessor: "insta.average_reel_view",
    title: "Insta Ortalama Reel İzlenme",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.insta_average_reel_view)}
        </div>
      )
    },
  },
  {
    accessor: "insta.face_count",
    title: "Insta Yüz Sayısı",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.insta_face_count)}
        </div>
      )
    },
  },
  {
    accessor: "insta.engagement_rate",
    title: "Insta Etkileşim Oranı",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.insta_engagement_rate != null
            ? Number(record.insta_engagement_rate).toFixed(2)
            : "-"}
        </div>
      )
    },
  },
  {
    accessor: "insta.post_number",
    title: "Insta Gönderi Sayısı",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.insta_post_number}
        </div>
      )
    },
  },
  {
    accessor: "tiktok.followers",
    title: "TikTok Takipçi",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.tiktok_followers)}
        </div>
      )
    },
  },
  {
    accessor: "tiktok.following",
    title: "TikTok Takip",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.tiktok_following)}
        </div>
      )
    },
  },
  {
    accessor: "tiktok.tiktok_average_like",
    title: "TikTok Ortalama Beğeni",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.tiktok_average_like)}
        </div>
      )
    },
  },
  {
    accessor: "tiktok.tiktok_engagement_rate",
    title: "TikTok Etkileşim Oranı",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {record.tiktok_engagement_rate != null
            ? Number(record.tiktok_engagement_rate).toFixed(2)
            : "-"}
        </div>
      )
    },
  },
  {
    accessor: "tiktok.hearts",
    title: "TikTok Kalp Sayısı",
    sortable: true,
    render: (record) => {
      return (
        <div
          onClick={() => {
            setSelectedUser(record)
            setIsOpenDetailModal(true)
          }}
        >
          {numFixer(record.tiktok_hearts)}
        </div>
      )
    },
  },
]
